import { Avatar } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { FC, memo } from "react";
import { getConversationUsername } from "./utils";

type WebChatAvatarSize = "md" | "lg";

interface WebChatAvatarProps {
  conversationName: string;
  size: WebChatAvatarSize;
}

const textClassesBySize: Record<WebChatAvatarSize, string> = {
  md: "text-base",
  lg: "text-lg",
};

export const WebChatAvatar: FC<WebChatAvatarProps> = memo(
  ({ conversationName, size }) => {
    const username = getConversationUsername(conversationName);

    return (
      <Avatar
        imageUrl={undefined}
        size="md"
        username={username}
        className={cx(
          "border border-solid border-grey-300",
          size === "md" ? "h-10 w-10" : "h-12 w-12"
        )}
        labelClassName={textClassesBySize[size]}
      />
    );
  }
);
